<!--
 * @Descripttion: 
 * @Author: chenjinsheng
 * @Date: 2021-11-16 09:31:37
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-16 10:46:26
-->
<template>
    <el-dialog
        title="请选择城市公司"
        :append-to-body="true"
        :visible.sync="projectDialogVisible"
        width="30%"
        @close="cityBtnOption('no')"
    >
        <el-select v-model="cityId" v-loading="loading" size="medium" style="width:100%;">
            <el-option
                v-for="(city, index) in cityList"
                :key="index"
                :label="city.buName"
                :value="city.buguid"
            ></el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="cityBtnOption('no')">取 消</el-button>
            <el-button size="small" type="primary" @click="cityBtnOption('yes')">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { getOrganization } from "@/api";
export default {
    name: "CityDialog",
    data() {
        return {
            loading: false,
            projectDialogVisible: false,
            cityId: "",
            data: {},
            cityList: [],
        };
    },
    methods: {
        show(item) {
            this.projectDialogVisible = true;
            this.data = item;
            this.initCity();
        },
        async initCity() {
            this.loading = true;
            try {
                const { code, message, body } = await getOrganization({
                    status: "",
                    buguid: "",
                    keyword: "",
                    filterEmpty: "",
                });

                if (code === "0000") {
                    this.cityList = body.businessUnits;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                this.$message.error(err.data.message || "系统错误");
            }
            this.loading = false;
        },
        /**
         * 城市选择操作按钮
         * 取消：关闭弹框，清空cityId
         * 确定：判断cityId是否有值，若有，关闭，若无，进行提示
         */
        cityBtnOption(btnTye) {
            if (btnTye === "no") {
                //取消
                this.cityId = "";
                this.projectDialogVisible = false;
                return;
            }

            //确定
            if (this.cityId === "") {
                this.$message.error("请选择城市公司");
                return false;
            }

            const { type, openMode, ifToken } = this.data;
            let url = "";
            if (type === "project") {
                // 新增项目
                url = this.$config.projectUrl;
            } else if (type === "land") {
                // 新增土地块
                url = this.$config.landmassUrl;
            }
            url = `${url}&orgId=${this.cityId}`;
            this.projectDialogVisible = false;
            this.handleRouterJump(openMode, url, "", ifToken);
        },
    },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
    border-radius: 8px !important;
}
/deep/ .el-dialog__header {
    border-radius: 8px 8px 0 0 !important;
}
</style>
